import { FC, ReactNode } from "react";
import classNames from "classnames";

type Padding = "none" | "sm" | "md" | "lg";

const paddingMap: Record<Padding, string> = {
  none: "",
  sm: "p-4",
  md: "p-6",
  lg: "p-8",
};

type Props = {
  children: ReactNode;
  className?: string;
  padding?: Padding;
  title?: string;
  subtitle?: string;
  headerAction?: ReactNode;
};

export const EvoCard: FC<Props> = ({
  children,
  className,
  padding = "md",
  title,
  subtitle,
  headerAction,
}) => {
  const hasHeader = title || subtitle || headerAction;

  return (
    <section
      className={classNames(
        "rounded-2xl border border-evo-border bg-evo-surface shadow-[var(--evo-shadow-sm)]",
        paddingMap[padding],
        className
      )}
    >
      {hasHeader ? (
        <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div>
            {title ? (
              <h2 className="text-base font-semibold tracking-tight text-evo-text">{title}</h2>
            ) : null}
            {subtitle ? (
              <p className="mt-0.5 text-sm text-evo-muted">{subtitle}</p>
            ) : null}
          </div>
          {headerAction ? <div className="shrink-0">{headerAction}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
};
